module.exports = __webpack_public_path__ + "static/media/EnvPromo02.5b979714.jpg";